import React from 'react';
import classNames from 'classnames';
import css from './IconFavourite.module.css';

const IconFavourite = props => {
  const { isFavourite } = props

  const classes = classNames(
    css.root,
    { [css.rootActive]: isFavourite },
  );

  return (
    <div className={classes}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        fill="none"
        viewBox="0 0 18 16"
      >
        <path
          fill="#F8F8F8"
          fillOpacity="0.51"
          stroke="#fff"
          d="M12.307.595c2.075-.369 3.474.364 4.29 1.474.787 1.07 1.063 2.53.814 3.826l-.056.256c-.52 2.062-2.054 4.065-3.734 5.73-1.668 1.654-3.425 2.922-4.31 3.522a.55.55 0 0 1-.617.003c-.88-.6-2.638-1.869-4.307-3.524-1.68-1.666-3.217-3.67-3.74-5.732C.305 4.796.561 3.21 1.4 2.07 2.165 1.027 3.441.32 5.308.54l.38.056c.756.135 1.47.67 2.026 1.231a8 8 0 0 1 .852 1.03l.012.017.421.652.42-.653.002-.003.009-.015.043-.061a7.743 7.743 0 0 1 .807-.967c.553-.56 1.268-1.096 2.028-1.231z"
          data-figma-bg-blur-radius="7"
        ></path>
        <defs>
          <clipPath id="bgblur_0_325_46_clip_path" transform="translate(7 7)">
            <path d="M12.307.595c2.075-.369 3.474.364 4.29 1.474.787 1.07 1.063 2.53.814 3.826l-.056.256c-.52 2.062-2.054 4.065-3.734 5.73-1.668 1.654-3.425 2.922-4.31 3.522a.55.55 0 0 1-.617.003c-.88-.6-2.638-1.869-4.307-3.524-1.68-1.666-3.217-3.67-3.74-5.732C.305 4.796.561 3.21 1.4 2.07 2.165 1.027 3.441.32 5.308.54l.38.056c.756.135 1.47.67 2.026 1.231a8 8 0 0 1 .852 1.03l.012.017.421.652.42-.653.002-.003.009-.015.043-.061a7.743 7.743 0 0 1 .807-.967c.553-.56 1.268-1.096 2.028-1.231z"></path>
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default IconFavourite;
